<template>
  <v-container fluid>
    <breadcrumb :items="breadcrumbs" />
    <v-row class="align-center justify-space-between mb-10">
      <v-col cols="8">
        <h1 class="font-weight-bold"> {{ isEditMode ? 'Edit Plot Tree Mapping Request' : 'Add New Plot Tree Mapping Request' }} </h1>
      </v-col>
      <v-col cols="4" class="text-right">
        <v-btn text color="primary" outlined @click="cancelForm">Cancel</v-btn> &nbsp;
        <v-btn color="primary" dark @click="submitRequest"> {{ isEditMode ? 'Update Request' : 'Submit Request' }}</v-btn>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-text>
        <v-form ref="form" v-model="isFormValid">
          <v-row>
            <v-col cols="12" md="4" class="assign-to-col">
              <label> Assign To </label>
              <div class="d-flex assign-to-fields">
                <v-autocomplete 
                  :items="roles" 
                  item-text="name" 
                  item-value="id" 
                  placeholder="Select Role"
                  outlined
                  dense 
                  v-model="selectedRole" 
                  @change="getUsersByRole"
                  class="assign-to-role"
                />
                <v-autocomplete 
                  :items="assigneeSearchResults" 
                  item-text="fullName" 
                  item-value="userId" 
                  placeholder="Select Name"
                  outlined 
                  dense 
                  v-model="selectedAssignee"
                  :search-input.sync="assigneeSearchInput"
                  :loading="assigneesSearchLoading"
                  no-filter
                  @update:search-input="onAssigneeSearchInput"
                  @focus="onAssigneeFieldFocus"
                  :disabled="!selectedRole"
                  class="assign-to-name"
                />
              </div>
            </v-col>

       

            <v-col cols="12" md="2">
              <label>Farmer Name </label>
              <v-autocomplete 
                :items="farmerSearchResults" 
                item-text="fullName" 
                item-value="userId" 
                :placeholder="$t('select')"
                outlined 
                dense 
                v-model="selectedFarmerId" 
                :search-input.sync="farmerSearchInput"
                :loading="farmersSearchLoading"
                no-filter
                @update:search-input="onFarmerSearchInput"
                @focus="onFarmerFieldFocus"
                @change="getFarmsByFarmer"
                :rules="[v => !!v || 'Farmer is required']"
              />
            </v-col>

            <v-col cols="12" md="2">
              <label>Farm Name </label>
              <v-autocomplete 
                :items="farmNames" 
                item-text="farmName" 
                item-value="id" 
                :placeholder="$t('select')"
                :loading="farmNamesLoading"
                outlined 
                dense 
                v-model="selectedFarmId"
                :rules="[v => !!v || 'Farm is required']"
                @change="onFarmSelected"
              />
            </v-col>

            <v-col v-if="isSuperAdmin" cols="12" md="2" class="start-due-date-col">
              <label> Start Date </label>
              <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                transition="scale-transition" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field 
                    v-model="startDate" 
                    readonly 
                    outlined 
                    dense 
                    v-bind="attrs" 
                    :placeholder="$t('select')"
                    v-on="on"
                    :rules="[v => !!v || 'Start date is required']"
                  >
                    <template v-slot:append>
                      <v-icon size="22" class="date-field-append-icon" @click="onStartDateAppendClick">{{ startDate ? 'mdi-close' : 'mdi-calendar' }}</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="startDate" no-title @input="startDateMenu = false" />
              </v-menu>
            </v-col>

            <v-col v-if="isSuperAdmin" cols="12" md="2" class="start-due-date-col">
              <label> Due Date </label>
              <v-menu ref="dueDateMenu" v-model="dueDateMenu" :close-on-content-click="false"
                transition="scale-transition" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field 
                    v-model="dueDate" 
                    readonly 
                    outlined 
                    dense 
                    v-bind="attrs" 
                    v-on="on"
                    :placeholder="$t('select')"
                    :rules="[v => !!v || 'Due date is required']"
                  >
                    <template v-slot:append>
                      <v-icon size="22" class="date-field-append-icon" @click="onDueDateAppendClick">{{ dueDate ? 'mdi-close' : 'mdi-calendar' }}</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="dueDate" no-title @input="dueDateMenu = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" md="6" class="farm-location-col">
              <label> Farm Location Address </label>
              <div @click="farmLocationHandler" class="farm-location-wrapper">
                <v-text-field 
                  @click="farmLocationHandler" 
                  readonly 
                  id="dialog-link1"
                  placeholder="Please click to choose location" 
                  outlined 
                  dense 
                  :value="farmLocationAddress"
                  class="farm-location-input">
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <label> Additional Notes </label>
              <v-text-field 
                v-model="notes"
                :placeholder="$t('enterHere')" 
                outlined 
                dense 
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col v-if="!isSuperAdmin" cols="12" md="2" class="start-due-date-col">
              <label> Start Date </label>
              <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                transition="scale-transition" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field 
                    v-model="startDate" 
                    readonly 
                    outlined 
                    dense 
                    v-bind="attrs" 
                    :placeholder="$t('select')"
                    v-on="on"
                    :rules="[v => !!v || 'Start date is required']"
                  >
                    <template v-slot:append>
                      <v-icon size="22" class="date-field-append-icon" @click="onStartDateAppendClick">{{ startDate ? 'mdi-close' : 'mdi-calendar' }}</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="startDate" no-title @input="startDateMenu = false" />
              </v-menu>
            </v-col>

            <v-col v-if="!isSuperAdmin" cols="12" md="2" class="start-due-date-col">
              <label> Due Date </label>
              <v-menu ref="dueDateMenu" v-model="dueDateMenu" :close-on-content-click="false"
                transition="scale-transition" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field 
                    v-model="dueDate" 
                    readonly 
                    outlined 
                    dense 
                    v-bind="attrs" 
                    v-on="on"
                    :placeholder="$t('select')"
                    :rules="[v => !!v || 'Due date is required']"
                  >
                    <template v-slot:append>
                      <v-icon size="22" class="date-field-append-icon" @click="onDueDateAppendClick">{{ dueDate ? 'mdi-close' : 'mdi-calendar' }}</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="dueDate" no-title @input="dueDateMenu = false" />
              </v-menu>
            </v-col>
            <v-row>
          <v-col cols="12" md="12" class="d-flex justify-end" >
            <div class="d-flex gap2 mr-4">
              <!-- <div v-if="!isSuperAdmin">
                <v-autocomplete 
                  :items="plotOptions" 
                  v-model="selectedPlot" 
                  item-text="plot_no"
                  label="Select Plot Number" 
                  outlined 
                  dense 
                  multiple 
                  chips 
                  deletable-chips 
                  return-object 
                />
              </div> -->
              <v-btn color="primary" outlined @click="plotLocation">ADD NEW PLOT</v-btn>
            </div>
          </v-col>
        </v-row>
            <v-col cols="12" md="12">
              <v-data-table 
                :headers="plotHeaders" 
                :items="sortedSelectedPlot" 
                class="mt-5" 
                dense 
                hide-default-footer
                :no-data-text="tableNoDataText"
              >
                <template v-slot:item.radius="{ item }">
                  <span>{{ formatRadiusMeters(item.radius) }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <div class="d-flex align-center" style="min-height: 40px;">
                    <v-btn xs-small rounded depressed :class="getPlotStatusClass(getPlotStatus(item))" height="24" min-width="70" class="text-capitalize">
                      {{ formatPlotStatus(getPlotStatus(item)) }}
                    </v-btn>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn text small color="error" @click="removePlot(item)">Remove</v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="my-4" />
      
      </v-card-text>
    </v-card>

    <v-card outlined class="mt-6">
      <v-card-text>
        <GmapMap 
          ref="gmap" 
          :center="{ lat: 20.5937, lng: 78.9629 }" 
          :zoom="4" 
          map-type-id="satellite"
          style="width: 100%; height: 500px"
        >
          <GmapCluster>
            <GmapMarker 
              v-for="plot in plotOptions" 
              :key="plot.id"
              :position="{ lat: parseFloat(plot.latitude), lng: parseFloat(plot.longitude) }" 
              :clickable="true"
              :icon="getPlotIcon(plot)" 
              @click="togglePlotSelection(plot)" 
              :title="plot.plot_no" 
            />
          </GmapCluster>
        </GmapMap>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import CarbonCreditService from '@/_services/CarbonCreditService';
import loading from "@/mixins/LoadingMixin";
import MemberDataService from '@/_services/MemberDataService';
import RoleMixin from "@/mixins/RoleMixin";
import GmapCluster from 'vue2-google-maps/dist/components/cluster';

export default {
  components: { GmapCluster },
  mixins: [loading, RoleMixin],

  async created() {
    this.requestId = this.$route.params.id;
    this.isEditMode = !!this.requestId;
    const draft = this.$store.getters['carbonCredit/getAddPlotTreeDraft'];
    const isReturningFromAddFlow = !this.isEditMode && draft && this.hasExpandedDraftData(draft);

    if (isReturningFromAddFlow) {
      const selectedPlotIds = draft.selectedPlotIds;
      this.restoreDraftFromStore(true);
      const newlyAdded = this.$store.getters['carbonCredit/getNewlyAddedPlot'];
      if (newlyAdded && newlyAdded.id) {
        this.mergeNewlyAddedPlot(newlyAdded);
        this.$store.dispatch('carbonCredit/clearNewlyAddedPlot');
      }
      const needsPlotFetch = this.farmLocation?.latitude != null && this.plotOptions.length === 0;
      if (needsPlotFetch) {
        this.startLoading();
        try {
          await this.getTreePlots();
          if (Array.isArray(this.plotOptions) && this.plotOptions.length > 0) {
            if (Array.isArray(selectedPlotIds) && selectedPlotIds.length > 0) {
              this.selectedPlot = this.plotOptions.filter(p => selectedPlotIds.includes(p.id));
            } else {
              this.selectedPlot = [...this.plotOptions];
            }
          }
        } finally {
          this.stopLoading();
        }
      }
      this.$nextTick(() => this.fitMapToBounds());
      return;
    }

    this.startLoading();
    try {
      await this.getRoles();
      if (!this.isEditMode) {
        await this.getTreePlots();
      }
      if (this.isEditMode) {
        await this.loadRequestData();
        const farmLocationJustSaved = this.$store.getters['carbonCredit/getFarmLocationJustSaved'];
        if (farmLocationJustSaved && this.farmLocation?.latitude != null) {
          const plotsBeforeSearch = [...this.selectedPlot];
          await this.getTreePlots();
          // Merge: keep existing request plots (may be outside new farm area) + add new from search
          const existingIds = new Set(plotsBeforeSearch.map(p => Number(p.id)));
          const newFromSearch = (this.plotOptions || []).filter(p => !existingIds.has(Number(p.id)));
          this.selectedPlot = [...plotsBeforeSearch, ...newFromSearch];
          const byId = new Map();
          // Add search results first, then request plots - so submitted plot info (trees, attachments) is preserved
          [...(this.plotOptions || []), ...plotsBeforeSearch].forEach(p => byId.set(Number(p.id), p));
          this.plotOptions = Array.from(byId.values());
          this.$store.dispatch('carbonCredit/clearFarmLocationJustSaved');
        }
        this.$nextTick(() => this.fitMapToBounds());
      } else {
        await this.restoreDraftFromStore(false);
        if (this.selectedFarmerId && this.farmerSearchResults.length === 0) {
          await this.searchFarmers('');
        }
      }
      const pendingEdit = this.$store.getters['carbonCredit/getPendingEditSelectedPlots'];
      const newlyAdded = this.$store.getters['carbonCredit/getNewlyAddedPlot'];
      if (this.isEditMode && pendingEdit && (Array.isArray(pendingEdit.selectedPlot) || Array.isArray(pendingEdit.plotOptions))) {
        if (Array.isArray(pendingEdit.selectedPlot) && pendingEdit.selectedPlot.length > 0) {
          this.selectedPlot = [...pendingEdit.selectedPlot];
        }
        if (Array.isArray(pendingEdit.plotOptions) && pendingEdit.plotOptions.length > 0) {
          this.plotOptions = [...pendingEdit.plotOptions];
        }
        this.$store.dispatch('carbonCredit/clearPendingEditSelectedPlots');
      }
      if (newlyAdded && newlyAdded.id) {
        this.mergeNewlyAddedPlot(newlyAdded);
        this.$store.dispatch('carbonCredit/clearNewlyAddedPlot');
      }
    } finally {
      this.stopLoading();
    }
  },

  async activated() {
    const newlyAdded = this.$store.getters['carbonCredit/getNewlyAddedPlot'];
    const pendingEdit = this.$store.getters['carbonCredit/getPendingEditSelectedPlots'];
    const farmLocationJustSaved = this.$store.getters['carbonCredit/getFarmLocationJustSaved'];
    const hasAsyncWork =
      (this.isEditMode && (pendingEdit || (farmLocationJustSaved && this.farmLocation?.latitude != null))) ||
      (!this.isEditMode && (this.farmLocation?.latitude != null || (this.plotOptions && this.plotOptions.length) > 0)) ||
      newlyAdded;
    if (!hasAsyncWork) return;

    this.startLoading();
    try {
      if (this.isEditMode && pendingEdit && (Array.isArray(pendingEdit.selectedPlot) || Array.isArray(pendingEdit.plotOptions))) {
        if (Array.isArray(pendingEdit.selectedPlot) && pendingEdit.selectedPlot.length > 0) {
          this.selectedPlot = [...pendingEdit.selectedPlot];
        }
        if (Array.isArray(pendingEdit.plotOptions) && pendingEdit.plotOptions.length > 0) {
          this.plotOptions = [...pendingEdit.plotOptions];
        }
        this.$store.dispatch('carbonCredit/clearPendingEditSelectedPlots');
      }
      if (this.isEditMode && farmLocationJustSaved && this.farmLocation?.latitude != null) {
        const plotsBeforeSearch = [...this.selectedPlot];
        await this.getTreePlots();
        const existingIds = new Set(plotsBeforeSearch.map(p => Number(p.id)));
        const newFromSearch = (this.plotOptions || []).filter(p => !existingIds.has(Number(p.id)));
        this.selectedPlot = [...plotsBeforeSearch, ...newFromSearch];
        const byId = new Map();
        // Add search results first, then request plots - so submitted plot info (trees, attachments) is preserved
        [...(this.plotOptions || []), ...plotsBeforeSearch].forEach(p => byId.set(Number(p.id), p));
        this.plotOptions = Array.from(byId.values());
        this.$store.dispatch('carbonCredit/clearFarmLocationJustSaved');
      } else if (!this.isEditMode) {
        const hasFarmLocation = this.farmLocation?.latitude != null;
        if (hasFarmLocation || this.plotOptions?.length) {
          await this.getTreePlots();
          if (Array.isArray(this.plotOptions) && this.plotOptions.length > 0) {
            this.selectedPlot = [...this.plotOptions];
          }
        }
      }
      if (newlyAdded && newlyAdded.id) {
        this.mergeNewlyAddedPlot(newlyAdded);
        this.$store.dispatch('carbonCredit/clearNewlyAddedPlot');
      }
      this.$nextTick(() => this.fitMapToBounds());
    } finally {
      this.stopLoading();
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.isEditMode && to.name === 'plotLocation') {
      this.$store.dispatch('carbonCredit/setPendingEditSelectedPlots', {
        selectedPlot: [...(this.selectedPlot || [])],
        plotOptions: [...(this.plotOptions || [])]
      });
    } else if (!this.isEditMode) {
      const saveDraftRoutes = ['ChooseFarmLocation', 'plotLocation'];
      if (saveDraftRoutes.includes(to.name)) {
        this.saveDraftToStore();
      } else {
        this.clearFormData();
      }
    }
    next();
  },

  data() {
    return {
      fullPage: true,
      breadcrumbs: [
        { text: 'Dashboard', disabled: false },
        { text: 'Carbon Credit', disabled: true },
        { text: 'Plot Tree Maping', disabled: true },
      ],
      roles: [],
      assignees: [],
      assigneeSearchResults: [],
      assigneeSearchInput: '',
      assigneesSearchLoading: false,
      assigneeSearchDebounce: null,
      farmNames: [],
      farmNamesLoading: false,
      selectedRole: null,
      selectedAssignee: null,
      selectedFarmerId: null,
      selectedFarmId: null,
      plotOptions: [],
      startDate: null,
      dueDate: null,
      notes: '',
      startDateMenu: false,
      dueDateMenu: false,
      selectedPlot: [],
      isFormValid: false,
      plotHeaders: [
        { text: 'Plot Number', value: 'plot_no' },
        { text: 'Longitude', value: 'longitude' },
        { text: 'Latitude', value: 'latitude' },
        { text: 'Radius', value: 'radius' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'end' },
      ],
      defaultPlotIcon: '/assets/icons/defaultPlot.svg',
      selectedPlotIcon: '/assets/icons/selectedPlot.svg',
      isEditMode: false,
      requestId: null,
      farmerSearchResults: [],
      farmerSearchInput: '',
      farmersSearchLoading: false,
      farmerSearchDebounce: null,
    };
  },
  computed: {
    ...mapGetters({
      farmLocation: 'carbonCredit/getFarmLocation',
      farmList: 'memberData/farms',
    }),
    isSuperAdmin() {
      return this.getCurrentRoles && Array.isArray(this.getCurrentRoles) &&
        this.getCurrentRoles.some(role => role === 'super_admin');
    },
    farmLocationAddress() {
      return this.farmLocation ? this.farmLocation.address : null;
    },
    sortedSelectedPlot() {
      const list = this.selectedPlot || [];
      return [...list].sort((a, b) => {
        const aDate = a.created_at ? new Date(a.created_at).getTime() : 0;
        const bDate = b.created_at ? new Date(b.created_at).getTime() : 0;
        return bDate - aDate;
      });
    },
    tableNoDataText() {
      if (!this.farmLocation && this.selectedPlot.length === 0) {
        return 'Set farm location to load plots, or add a new plot.';
      }
      if (this.selectedPlot.length === 0) {
        return 'No plots found for this farm location. Click "ADD NEW PLOT" to add one.';
      }
      return 'No plots';
    },
  },
  methods: {
    async getRoles() {
      try {
        const cached = this.$store.getters['carbonCredit/getCachedUserMembershipRoleResponse'];
        let data;
        if (cached && cached.data && Array.isArray(cached.data.listRes)) {
          data = cached;
        } else {
          const res = await this.$http.get("/user/membership/user-role");
          data = res.data;
          this.$store.commit('carbonCredit/SET_USER_MEMBERSHIP_ROLE_RESPONSE', data);
        }
        const roles = (data.data?.listRes || []).filter(x => {
          if (x.id == 'avocado_farmer') return false;
          return true;
        });
        this.roles = roles;
      } catch (e) {
        console.log(e);
      }
    },
    async getUsersByRole(opts = {}) {
      if (!this.selectedRole) return;
      const { skipLoading, preserveAssignee } = opts;
      if (!preserveAssignee) {
        this.selectedAssignee = null;
        this.assigneeSearchResults = [];
        this.assigneeSearchInput = '';
      }
      if (!skipLoading) this.startLoading();
      try {
        await this.searchUsersByRole('');
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Failed to fetch users. Please try again.'
        });
        this.assigneeSearchResults = [];
      } finally {
        if (!skipLoading) this.stopLoading();
      }
    },
    formatAssignee(user) {
      const userId = user.userId ?? user.id;
      const fullName = user.fullName ?? (`${user.first_name || user.firstName || ''} ${user.last_name || user.lastName || ''}`.trim() || `User ${userId}`);
      return { ...user, userId, fullName };
    },
    onAssigneeSearchInput(val) {
      if (!this.selectedRole) return;
      if (this.assigneeSearchDebounce) clearTimeout(this.assigneeSearchDebounce);
      const trimmed = (val || '').trim();
      if (this.selectedAssignee && trimmed) {
        const selected = this.assigneeSearchResults.find(u => String(u.userId) === String(this.selectedAssignee));
        if (selected && selected.fullName && trimmed === selected.fullName) return;
      }
      this.assigneeSearchDebounce = setTimeout(() => {
        this.searchUsersByRole(val || '');
      }, 300);
    },
    onAssigneeFieldFocus() {
      if (!this.selectedRole) return;
      if (this.assigneeSearchResults.length === 0 && !this.assigneesSearchLoading) {
        this.searchUsersByRole(this.assigneeSearchInput || '');
      }
    },
    async searchUsersByRole(searchPhrase) {
      if (!this.selectedRole) return;
      this.assigneesSearchLoading = true;
      try {
        const res = await CarbonCreditService.getUsersByRole({
          role_id: this.selectedRole,
          page: 1,
          limit: 1000,
          name: (searchPhrase || '').trim()
        });
        const raw = res?.data ?? (Array.isArray(res) ? res : []);
        const list = Array.isArray(raw) ? raw : [];
        let results = list.map(u => this.formatAssignee(u)).filter(u => u.userId != null);
        if (this.selectedAssignee) {
          const hasSelected = results.some(u => String(u.userId) === String(this.selectedAssignee));
          if (!hasSelected) {
            const selectedFromCurrent = this.assigneeSearchResults.find(
              u => String(u.userId) === String(this.selectedAssignee)
            );
            if (selectedFromCurrent) {
              results = [selectedFromCurrent, ...results];
            } else if (this._restoredAssigneeName) {
              results = [{ userId: this.selectedAssignee, fullName: this._restoredAssigneeName || `User ${this.selectedAssignee}` }, ...results];
            }
            this._restoredAssigneeName = null;
          }
        }
        this.assigneeSearchResults = results;
      } catch (error) {
        console.error('Error searching users:', error);
        this.assigneeSearchResults = [];
        this.$notify({ type: 'error', text: 'Failed to search users' });
      } finally {
        this.assigneesSearchLoading = false;
      }
    },
    async getFarmsByFarmer() {
      if (!this.selectedFarmerId) {
        this.farmNames = [];
        this.selectedFarmId = null;
        this.$store.dispatch('carbonCredit/clearFarmLocation');
        this.plotOptions = [];
        this.selectedPlot = [];
        return;
      }
      this.farmNamesLoading = true;
      try {
        const res = await MemberDataService.getFarmsByFarmers({
          userId: this.selectedFarmerId,
          page: 1,
          limit: 10000
        });
        this.farmNames = res.data?.farms || [];
      } catch (e) {
        this.farmNames = [];
      } finally {
        this.farmNamesLoading = false;
      }
    },
    onFarmSelected() {
      if (!this.selectedFarmId) {
        this.$store.dispatch('carbonCredit/clearFarmLocation');
        this.selectedPlot = [];
        this.plotOptions = [];
        return;
      }
      const farm = Array.isArray(this.farmNames)
        ? this.farmNames.find(f => String(f.id) === String(this.selectedFarmId))
        : null;
      if (!farm) return;
      const lat = farm.latitude ?? farm.lat;
      const lng = farm.longitude ?? farm.log;
      if (lat != null && lng != null) {
        const hasArea = farm.area != null && farm.area !== '';
        const farmLocation = {
          latitude: parseFloat(lat),
          longitude: parseFloat(lng),
          address: farm.address || null,
          areaSize: hasArea ? String(farm.area) : '',
          areaUnit: hasArea ? 'acres' : undefined, // farm.area from API is in acres
          country: farm.country || null,
        };
        this.$store.dispatch('carbonCredit/setFarmLocation', farmLocation);
        // In edit mode, don't search plots until user saves from Farm Location
        if (!this.isEditMode) {
          this.getTreePlots();
        }
      } else {
        this.$store.dispatch('carbonCredit/clearFarmLocation');
        this.plotOptions = [];
      }
    },
    formatFarmer(farmer) {
      const userId = farmer.userId ?? farmer.user_id ?? farmer.id ?? farmer.farmerId ?? farmer.farmer_id;
      const firstName = farmer.firstName ?? farmer.first_name ?? '';
      const lastName = farmer.lastName ?? farmer.last_name ?? '';
      const fullNameRaw = farmer.fullName ?? farmer.farmerName ?? farmer.name ?? `${firstName} ${lastName}`.trim();
      const fullName = (fullNameRaw || '').trim() || `User ${userId ?? ''}`.trim();
      return { ...farmer, userId, fullName };
    },
    onFarmerSearchInput(val) {
      if (this.farmerSearchDebounce) clearTimeout(this.farmerSearchDebounce);
      const trimmed = (val || '').trim();
      if (this.selectedFarmerId && trimmed) {
        const selected = this.farmerSearchResults.find(f => String(f.userId) === String(this.selectedFarmerId));
        if (selected && selected.fullName && trimmed === selected.fullName) {
          return;
        }
      }
      this.farmerSearchDebounce = setTimeout(() => {
        this.searchFarmers(val || '');
      }, 300);
    },
    onFarmerFieldFocus() {
      if (this.farmerSearchResults.length === 0 && !this.farmersSearchLoading) {
        this.searchFarmers(this.farmerSearchInput || '');
      }
    },
    async searchFarmers(searchPhrase) {
      this.farmersSearchLoading = true;
      try {
        const isSuperAdmin = this.getCurrentRoles && Array.isArray(this.getCurrentRoles) &&
          this.getCurrentRoles.some(role => role === 'super_admin');
        const params = {
          page: 1,
          limit: 1000,
          active: true,
          searchPhrase: (searchPhrase || '').trim()
        };
        const data = isSuperAdmin
          ? await MemberDataService.getAllFarmers(params)
          : await MemberDataService.getFarmers(params);
        const raw = data?.data?.response ?? data?.response ?? (Array.isArray(data?.data) ? data.data : []);
        const list = Array.isArray(raw) ? raw : [];
        let results = list.map(f => this.formatFarmer(f)).filter(f => f.userId != null);
        if (this.selectedFarmerId) {
          const hasSelected = results.some(f => String(f.userId) === String(this.selectedFarmerId));
          if (!hasSelected) {
            const selectedFromCurrent = this.farmerSearchResults.find(
              f => String(f.userId) === String(this.selectedFarmerId)
            );
            if (selectedFromCurrent) {
              results = [selectedFromCurrent, ...results];
            }
          }
        }
        this.farmerSearchResults = results;
      } catch (error) {
        console.error('Error searching farmers:', error);
        this.farmerSearchResults = [];
        this.$notify({ type: 'error', text: 'Failed to search farmers' });
      } finally {
        this.farmersSearchLoading = false;
      }
    },
    plotLocation() {
      this.$router.push({
        name: 'plotLocation',
        query: this.requestId ? { requestId: this.requestId } : {}
      });
    },
    farmLocationHandler() {
      this.$router.push({
        name: 'ChooseFarmLocation',
        query: this.requestId ? { requestId: this.requestId } : {}
      });
    },
    onStartDateAppendClick(e) {
      if (this.startDate) {
        e.stopPropagation();
        this.startDate = null;
        this.startDateMenu = false;
      }
    },
    onDueDateAppendClick(e) {
      if (this.dueDate) {
        e.stopPropagation();
        this.dueDate = null;
        this.dueDateMenu = false;
      }
    },
    mergeNewlyAddedPlot(plot) {
      if (!plot || !plot.id) return;
      const existsInOptions = this.plotOptions.some(p => p.id === plot.id);
      if (!existsInOptions) {
        this.plotOptions = [...this.plotOptions, plot];
      }
      const existsInSelected = this.selectedPlot.some(p => p.id === plot.id);
      if (!existsInSelected) {
        this.selectedPlot = [...this.selectedPlot, plot];
      }
      this.fitMapToBounds();
    },
    removePlot(plotToRemove) {
      this.selectedPlot = this.selectedPlot.filter(plot => plot.id !== plotToRemove.id);
    },
    getPlotStatus(plot) {
      return (plot && (plot.plotStatus && plot.plotStatus.status)) || plot?.status || null;
    },
    getPlotStatusClass(status) {
      switch (status) {
        case 'submitted':
          return 'green-button';
        case 'pending':
          return 'gray-button';
        case 'in_progress':
        case 'partially_submitted':
          return 'orange-button';
        default:
          return 'gray-button';
      }
    },
    formatPlotStatus(status) {
      if (!status) return 'Pending';
      const statusMap = {
        'pending': 'Pending',
        'in_progress': 'Partially Submitted',
        'partially_submitted': 'Partially Submitted',
        'submitted': 'Submitted',
      };
      return statusMap[status] || status;
    },
    getPlotIcon(plot) {
      const isSelected = this.selectedPlot.some(p => p.id === plot.id);
      const icon = {
        url: isSelected ? this.selectedPlotIcon : this.defaultPlotIcon,
        scaledSize: new window.google.maps.Size(40, 40),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(20, 40),
      };
      return icon;
    },
    togglePlotSelection(plot) {
      const plotIndex = this.selectedPlot.findIndex(p => p.id === plot.id);
      if (plotIndex > -1) {
        this.selectedPlot.splice(plotIndex, 1);
      } else {
        this.selectedPlot.push(plot);
      }
    },
    fitMapToBounds() {
      this.$nextTick(() => {
        if (!this.plotOptions.length || !this.$refs.gmap) return;

        this.$refs.gmap.$mapPromise.then(map => {
          const bounds = new window.google.maps.LatLngBounds();
          this.plotOptions.forEach(plot => {
            bounds.extend({
              lat: parseFloat(plot.latitude),
              lng: parseFloat(plot.longitude)
            });
          });
          map.fitBounds(bounds);
        });
      });
    },
    async getTreePlots() {
      const loc = this.farmLocation;
      const params = {};
      if (loc?.latitude != null && loc?.longitude != null) {
        params.latitude = loc.latitude;
        params.longitude = loc.longitude;
        if (loc.areaSize != null && loc.areaSize !== '' && loc.areaUnit) {
          params.areaSize = loc.areaSize;
          params.areaUnit = loc.areaUnit;
        } else {
          params.radius_km = 2;
        }
      }
      if (this.isEditMode && this.requestId) params.requestId = this.requestId;
      const hasLocationFilter = Object.keys(params).length > 0;
      const response = await CarbonCreditService.getTreePlots(params);
      if (response && response.success !== false) {
        const raw = response.data;
        const plotsList = Array.isArray(raw)
          ? raw
          : (Array.isArray(raw?.data) ? raw.data : raw?.info || []);
        this.plotOptions = plotsList;
        if (hasLocationFilter) {
          this.selectedPlot = [...plotsList];
        }
        this.fitMapToBounds();
      }
    },
    async loadRequestData() {
      try {
        const response = await CarbonCreditService.getPlotTreeMappingRequestById(this.requestId);
        if (response.success) {
          const data = response.data;
          this.selectedFarmerId = data.farmer_id;
          this.selectedFarmId = data.farm_id;
          this.startDate = data.start_date;
          this.dueDate = data.due_date;
          this.notes = data.notes;
          if (data.farmer) {
            const formatted = this.formatFarmer({ ...data.farmer, userId: data.farmer.id ?? data.farmer_id });
            this.farmerSearchResults = [formatted];
          }
          if (Array.isArray(data.assignees) && data.assignees.length > 0) {
            const a = data.assignees[0];
            this.selectedRole = a.assignee_role ?? null;
            this.selectedAssignee = a.assignee_id ?? null;
            if (a.assignee) {
              const formatted = this.formatAssignee({ ...a.assignee, userId: a.assignee.id ?? a.assignee_id });
              this.assigneeSearchResults = [formatted];
            }
          }
          let plotIds = [];
          const plotObjects = Array.isArray(data.plots)
            ? (typeof data.plots[0] === 'object' ? data.plots : [])
            : [];
          if (Array.isArray(data.plots)) {
            if (typeof data.plots[0] === 'object') {
              plotIds = data.plots.map(p => p.id);
            } else {
              plotIds = data.plots;
            }
          }
          if (this.plotOptions.length) {
            this.selectedPlot = this.plotOptions.filter(plot => plotIds.includes(plot.id));
          } else if (plotObjects.length > 0) {
            // Edit mode: show existing plots from request (no plot search yet)
            this.plotOptions = [...plotObjects];
            this.selectedPlot = [...plotObjects];
            this.pendingPlotIds = plotIds;
          } else {
            this.pendingPlotIds = plotIds;
          }
          if (this.selectedFarmerId) {
            await this.getFarmsByFarmer();
            this.onFarmSelected();
          }
        }
      } catch (error) {
        this.$notify({ type: 'error', text: 'Failed to load request data' });
      }
    },
    async submitRequest() {
      // Validate form
      if (!this.$refs.form.validate()) {
        this.$notify({ type: 'error', text: 'Please fill in all required fields' });
        return;
      }
      if (!this.isSuperAdmin && this.selectedPlot.length === 0) {
        this.$notify({ type: 'error', text: 'Please select at least one plot' });
        return;
      }
      this.startLoading();
      try {
        const selectedFarm = Array.isArray(this.farmNames)
          ? this.farmNames.find(f => f.id === this.selectedFarmId)
          : null;

        const farm_location_address =
          this.farmLocationAddress ||
          selectedFarm?.address ||
          null;

        let attachedFarmId = this.selectedFarmId ?? null;
        if (this.isSuperAdmin && !attachedFarmId && this.farmLocation?.latitude != null && this.farmLocation?.longitude != null) {
          try {
            const checkRes = await CarbonCreditService.checkFarmLocation(
              this.farmLocation.latitude,
              this.farmLocation.longitude
            );
            const result = checkRes?.data?.data ?? checkRes?.data;
            if (result && result.inside === false) {
              this.$notify({
                type: 'error',
                text: this.$t('carbonCredit.plotTreeMapping.errorPlotOutsideRegisteredFarm')
              });
              return;
            }
            if (result?.matchedFarms?.length > 0) {
              attachedFarmId = result.matchedFarms[0].farm_id;
            }
          } catch (err) {
            this.$notify({
              type: 'error',
              text: this.$t('carbonCredit.plotTreeMapping.errorCheckingFarmLocation') || 'Could not verify farm location.'
            });
            return;
          }
        }

        const assignees =
          this.selectedAssignee && this.selectedRole
            ? [{ assignee_id: this.selectedAssignee, assignee_role: this.selectedRole }]
            : [];

        const payload = {
          farmer_id: this.selectedFarmerId ?? null,
          farm_id: attachedFarmId ?? null,
          start_date: this.startDate,
          due_date: this.dueDate,
          notes: this.notes,
          farm_location_address,
          assignees,
          plots: this.selectedPlot.map(plot => plot.id)
        };
        if (selectedFarm?.country || this.farmLocation?.country) {
          payload.country = selectedFarm?.country || this.farmLocation?.country;
        }
        let response;
        if (this.isEditMode) {
          response = await CarbonCreditService.updatePlotTreeMapping(this.requestId, payload);
        } else {
          response = await CarbonCreditService.createPlotTreeMapping(payload);
        }
        if (response.success) {
          this.$notify({
            type: 'success',
            text: this.isEditMode
              ? 'Plot tree mapping request updated successfully'
              : 'Plot tree mapping request created successfully'
          });
          // Always clear saved form data on successful submission
          this.clearFormData();
          this.$router.push({ name: 'plotTreeMapping' });
        } else {
          this.$notify({
            type: 'error',
            text: response.message || 'Failed to save request'
          });
        }
      } catch (error) {
        const errData = error?.response?.data || error?.data;
        const errMsg = errData?.message || errData?.msg || 'An error occurred while saving the request';
        this.$notify({
          type: 'error',
          text: errMsg
        });
      } finally {
        this.stopLoading();
      }
    },
    clearFormData() {
      this.$store.dispatch('carbonCredit/clearAddPlotTreeDraft');
      this.$store.dispatch('carbonCredit/clearFarmLocation');
    },
    saveDraftToStore() {
      const selectedAssignObj = this.assigneeSearchResults.find(u => String(u.userId) === String(this.selectedAssignee));
      const selectedFarmerObj = this.farmerSearchResults.find(f => String(f.userId) === String(this.selectedFarmerId));
      const selectedFarmObj = this.farmNames.find(f => String(f.id) === String(this.selectedFarmId));
      this.$store.dispatch('carbonCredit/setAddPlotTreeDraft', {
        selectedRole: this.selectedRole,
        selectedAssignee: this.selectedAssignee,
        selectedAssigneeName: selectedAssignObj?.fullName ?? null,
        selectedFarmerId: this.selectedFarmerId,
        selectedFarmerName: selectedFarmerObj?.fullName ?? null,
        selectedFarmId: this.selectedFarmId,
        selectedFarmName: selectedFarmObj?.farmName ?? null,
        selectedFarm: selectedFarmObj,
        startDate: this.startDate,
        dueDate: this.dueDate,
        notes: this.notes,
        selectedPlotIds: (this.selectedPlot || []).map(p => p.id),
        plotOptions: this.plotOptions,
        selectedPlot: this.selectedPlot,
        roles: this.roles,
        assigneeSearchResults: this.assigneeSearchResults,
        farmerSearchResults: this.farmerSearchResults,
        farmNames: this.farmNames
      });
    },
    async restoreDraftFromStore(skipApis = false) {
      const draft = this.$store.getters['carbonCredit/getAddPlotTreeDraft'];
      if (!draft) return;

      this.selectedRole = draft.selectedRole ?? null;
      this.selectedAssignee = draft.selectedAssignee ?? null;
      this._restoredAssigneeName = draft.selectedAssigneeName ?? null;
      this.selectedFarmerId = draft.selectedFarmerId ?? null;
      this.selectedFarmId = draft.selectedFarmId ?? null;
      this.startDate = draft.startDate ?? null;
      this.dueDate = draft.dueDate ?? null;
      this.notes = draft.notes ?? '';

      if (skipApis && this.hasExpandedDraftData(draft)) {
        this.restoreFromExpandedDraft(draft);
      } else {
        const promises = [];
        if (this.selectedRole) promises.push(this.getUsersByRole({ skipLoading: true, preserveAssignee: true }));
        if (this.selectedFarmerId) promises.push(this.getFarmsByFarmer());
        await Promise.all(promises);

        if (this.selectedFarmerId) {
          this.onFarmSelected();
        }
        if (Array.isArray(this.plotOptions) && this.plotOptions.length > 0) {
          this.selectedPlot = [...this.plotOptions];
        }
      }
      this.$store.dispatch('carbonCredit/clearAddPlotTreeDraft');
    },
    hasExpandedDraftData(draft) {
      return !!(draft && (draft.plotOptions !== undefined || draft.roles !== undefined || draft.farmNames !== undefined));
    },
    restoreFromExpandedDraft(draft) {
      if (Array.isArray(draft.roles) && draft.roles.length > 0) {
        this.roles = draft.roles;
      }
      if (Array.isArray(draft.assigneeSearchResults) && draft.assigneeSearchResults.length > 0) {
        this.assigneeSearchResults = draft.assigneeSearchResults;
      } else if (this.selectedAssignee && draft.selectedAssigneeName) {
        this.assigneeSearchResults = [{ userId: this.selectedAssignee, fullName: draft.selectedAssigneeName }];
      }
      if (Array.isArray(draft.farmerSearchResults) && draft.farmerSearchResults.length > 0) {
        this.farmerSearchResults = draft.farmerSearchResults;
      } else if (this.selectedFarmerId && draft.selectedFarmerName) {
        this.farmerSearchResults = [{ userId: this.selectedFarmerId, fullName: draft.selectedFarmerName }];
      }
      if (Array.isArray(draft.farmNames) && draft.farmNames.length > 0) {
        this.farmNames = draft.farmNames;
      }
      if (Array.isArray(draft.plotOptions)) {
        this.plotOptions = draft.plotOptions;
      }
      if (Array.isArray(draft.selectedPlot)) {
        this.selectedPlot = draft.selectedPlot;
      } else if (Array.isArray(draft.selectedPlotIds) && draft.selectedPlotIds.length > 0 && this.plotOptions.length > 0) {
        this.selectedPlot = this.plotOptions.filter(p => draft.selectedPlotIds.includes(p.id));
      }
      this.$nextTick(() => this.fitMapToBounds());
    },
    cancelForm() {
      this.clearFormData();
      this.$router.push({ name: 'plotTreeMapping' });
    },
    formatRadiusMeters(value) {
      if (value === null || value === undefined || value === '') return '-';
      const numeric = Number(value);
      if (Number.isNaN(numeric)) return value;
      const meters = numeric / 100;
      return `${meters} m`;
    }
  },
  watch: {
    plotOptions(newVal) {
      if (this.isEditMode && this.requestId && this._pendingPlotIds) {
        this.selectedPlot = newVal.filter(plot => this._pendingPlotIds.includes(plot.id));
        this._pendingPlotIds = null;
      }
    }
  },
};
</script>

<style scoped>
.assign-to-col {
  min-width: 0;
}

.assign-to-fields {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.assign-to-role,
.assign-to-name {
  min-width: 160px;
  flex: 1 1 160px;
}

.start-due-date-col {
  max-width: 200px;
}

.date-field-append-icon {
  cursor: pointer;
  font-size: 22px !important;
}

.text-right {
  text-align: right;
}

.gap2 {
  gap: 15px;
}

.farm-location-col {
  min-width: 280px;
}

.farm-location-wrapper {
  cursor: pointer;
}

.farm-location-input {
  pointer-events: none;
}

.farm-location-input::v-deep input,
.farm-location-input::v-deep input::placeholder {
  color: #00BD73 !important;
  text-decoration: underline;
  opacity: 1;
}
</style>
